import React from "react";
import type { IncidentVm } from "@/features/daily/components/command/command-view-model";
import type { IncidentAction } from "@/features/daily/components/incidents/incident-command";

type Props = {
    incident: IncidentVm;
    pendingAction: IncidentAction | null;
    onAct: (action: IncidentAction) => void;
};

/**
 * SC-011/D30: the only actions that exist are acknowledge, assign-to-me and
 * unassign. There is no manual close — recovery is decided by evidence (FR-011).
 * C12: assignment is self-service only, so there is no free-text assignee and no
 * dialog to cancel.
 */
export const IncidentActions: React.FC<Props> = ({ incident, pendingAction, onAct }) => {
    const busy = pendingAction !== null;
    return (
        <div className="daily-actions">
            <button
                type="button"
                className="daily-button daily-button--primary"
                disabled={busy}
                aria-busy={pendingAction === "acknowledge"}
                onClick={() => onAct("acknowledge")}
            >
                {pendingAction === "acknowledge" ? "Reconociendo…" : "Reconocer"}
            </button>
            {incident.assignedToViewer ? (
                <button
                    type="button"
                    className="daily-button"
                    disabled={busy}
                    aria-busy={pendingAction === "unassign"}
                    onClick={() => onAct("unassign")}
                >
                    {pendingAction === "unassign" ? "Quitando asignación…" : "Quitarme"}
                </button>
            ) : (
                <button
                    type="button"
                    className="daily-button"
                    disabled={busy}
                    aria-busy={pendingAction === "assign"}
                    onClick={() => onAct("assign")}
                >
                    {pendingAction === "assign" ? "Asignando…" : "Asignarme"}
                </button>
            )}
        </div>
    );
};
